import { useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { ROUTE_PARAMS, ROUTES } from 'src/routes';
import { useUserActions } from 'src/store';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { useHistory } from 'src/services/useHistory';
import { VIEW_TYPE } from 'src/views/SharedPage/const';
import { MainStore } from '../store';

const useMainState = createStateSelectorHook(MainStore, ['projectData', 'activeView']);

export const useAutoRedirect = () => {
  const history = useHistory();
  const { projectData, activeView } = useMainState();
  const location = useLocation();
  const userActions = useUserActions();

  useEffect(() => {
    const cameFromLoginPage = location?.state?.from === ROUTES.SIGN_IN;
    const isSignedIn = !!userActions.getCurrentUser();
    const isSignedInAndHasSharedError =
      activeView === VIEW_TYPE.error && isSignedIn && cameFromLoginPage;

    if (isSignedInAndHasSharedError) {
      history.replace(ROUTES.ROOT);
    }

    if (projectData?.editable) {
      history.push(`${ROUTES.PROJECTS}/${projectData.id}?${ROUTE_PARAMS.view}=document`);
    }
  }, [history, projectData, location, activeView, userActions]);
};
